import { render, staticRenderFns } from "./MailToken.vue?vue&type=template&id=d2997d0e&scoped=true&"
import script from "./MailToken.vue?vue&type=script&lang=js&"
export * from "./MailToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2997d0e",
  null
  
)

export default component.exports